
import { defineComponent, onMounted, onBeforeUnmount, Ref, ref, watch } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { useRouter, useRoute } from "vue-router";
import { Modal } from "bootstrap";
import axios from "axios";
import useAlert from "@/composables/Alert";
import Title from "@/components/Title.vue"
import Button from "@/components/Button.vue"
import Api from "@/services/Api";
import Pagination from "@/components/Pagination.vue";
import useEmitter from "@/composables/Emmiter";
import ModalAdicionarLubrificante from "./components/ModalAdicionarLubrificante.vue";
import ModalEditarLubrificante from "./components/ModalEditarLubrificante.vue";
import { ElSkeleton, ElSkeletonItem } from 'element-plus'


export default defineComponent({
  name: "FiltroLubrificantes",
  components: {
    Title,
    Button,
    Pagination,
    ModalAdicionarLubrificante,
    ModalEditarLubrificante,
    ElSkeleton,
    ElSkeletonItem  
  },
  emits: ["alterarExibicao"],
  setup() {
    const page: Ref<number> = ref(1)
    const limit: Ref<number> = ref(10)
    const filtro: Ref<any> = ref({ marca: null, produto: null, tipo: null, viscosidade: null });
      
    const auxModal: any = ref();

    const { showTimeAlert } = useAlert();

    const loading = ref(false);
    const loadSalvar: Ref<boolean> = ref(false);
    const loadExcluir: Ref<boolean> = ref(false);
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    const spanWarning = ref(false);
    const spanWarningEdit = ref(false);

    const prodFinded = ref(false);

    const paginasNumeradas: Ref<any> = ref([]);

    const totalLubrificantes: Ref<number> = ref(0);
    const lubrificantes: Ref<any> = ref([]);
    const lubClicked: Ref<any> = ref([]);
    const marcasDeLubrificantes: Ref<any> = ref([]);
    const tipo = ref("");
    const nome = ref("");
    const viscosidade = ref("");
    const lubForm: Ref<any> = ref({
      marca: "",
      produto: "",
      viscosidade: "",
      tipo: "",
      combustivel: "",
      descricao: "",
      acea: "",
      api: "",
      ilsac: "",
      norma_bmw: "",
      norma_chrysler: "",
      norma_fiat: "",
      norma_ford: "",
      norma_gm: "",
      norma_jaguar_land_rover: "",
      norma_mercedes: "",
      norma_psa: "",
      norma_renault: "",
      norma_vw: "",
      imagem: "",
      correspondencia: ""
    });
    const pagination = ref<InstanceType<typeof Pagination> | null>(null);
    const skeleton: Ref<boolean> = ref(false);

    //Emitter para filtrar os itens do modal do cabeçalho
    const emitter = useEmitter();
    emitter.on("paramsFilter", (payload: any) => {
      // payload.paramsFilter vem do componente do header.
      // Se os nomes de campos forem os mesmos, faz merge direto:
      filtro.value = { ...filtro.value, ...payload.paramsFilter };

      // se for necessário mapear campos diferentes, faça aqui a transformação:
      // ex: if (payload.paramsFilter.nomeFantasia) filtro.value.produto = payload.paramsFilter.nomeFantasia

      // resetar paginação e refazer a busca
      page.value = 1;
      pagination.value?.resetPage?.(1);
      allLubrificantes();
    });


    function handleImgFileChange(event: Event, target: "lubForm" | "lubClicked" = "lubForm") {
      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];
      if (!file) return;

      if (target === "lubForm") {
        lubForm.value.imagem = file;
        // opcional: se quiser mostrar preview no modal de criação, use lubForm.value.imagemPreview
      } else {
        // edição
        lubClicked.value.imagem = file;
      }
    }

    //FUNCAO PARA PEGAR O TOKEN
    const getToken = async () => {
      return localStorage.getItem("token_usuario");
    };

    async function allLubrificantes() {
      try {
        skeleton.value = true;
        const res = await axios.get("getAllLubrificantesPaginado", {
          params: {
            pagina: page.value,
            limite: limit.value,
            ...filtro.value
          },
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        });
        skeleton.value = false;

        const retorno = res.data.data;
        
        lubrificantes.value = retorno.lubrificantes;
        totalLubrificantes.value = retorno.totalLubrificantes; 
        
        lubrificantes.value.length === 0 ? prodFinded.value = true : prodFinded.value = false;        

      } catch (err) {
        console.log(err);
      }
    }

    async function getMarcasProduto(){
      loading.value = true
      try{
        const { data } = await Api.get("getMarcasProdutoDbInfo", {tipoProduto: 'oleoMotor'});
        if(data.length === 0) {
          showTimeAlert("Não foi possivel obter as marcas dos produtos", "error");
        } else {
          marcasDeLubrificantes.value = data;
        }
      }catch(err){
        showTimeAlert("Não foi possivel obter as marcas dos produtos", "error");
        console.log(err);
        loading.value = false
      }finally{
        loading.value = false
      }
    }

    // listener para receber o evento vindo do modal
    const handleAddLubFromModal = async (payload: any) => {
      if (!payload || !payload.lubForm) return;
      lubForm.value = { ...payload.lubForm };
      await addLub();
    };

    if (emitter && emitter.on) {
      emitter.on("addLub", handleAddLubFromModal);
    }

    // remove listener ao desmontar o componente
    onBeforeUnmount(() => {
      if (emitter && emitter.off) {
        emitter.off("addLub", handleAddLubFromModal);
      }
    });

    async function addLub() {
      if (emitter && emitter.emit) emitter.emit("addLub:start");
      loading.value = true;

      try {
        // Constrói body (FormData se tiver arquivo)
        let body: any = lubForm.value;
        const headers: any = {
          Authorization: `Bearer ${await getToken()}`,
        };

        // Se houver arquivo no lubForm, use FormData
        if (lubForm.value?.imagem instanceof File) {
          const formData = new FormData();

          // anexa campos simples (skip File)
          Object.entries(lubForm.value).forEach(([key, val]) => {
            if (key === "imagem") return; // arquivo anexado depois
            if (val === undefined || val === null) {
              formData.append(key, "");
            } else if (typeof val === "object") {
              // se algum campo for objeto/array e precisa ser enviado como string
              formData.append(key, JSON.stringify(val));
            } else {
              formData.append(key, String(val));
            }
          });

          // Nome do campo do arquivo: ajuste se sua API espera 'imagem' em vez de 'imagem'
          formData.append("imagem", lubForm.value.imagem);

          body = formData;
          // NÃO setar Content-Type — axios cuidará do boundary automaticamente
        }

        const res = await axios.post("adicionaLubrificante", body, {
          headers
        });

        // limpeza: remover o arquivo do form local
        lubForm.value.imagem = "";

        if (lubrificantes.value.length) {
          lubrificantes.value = [];
        }
        await allLubrificantes();

        showTimeAlert("Produto adicionado com sucesso!");
        if (emitter && emitter.emit) emitter.emit("addLub:finish", { success: true });
      } catch (err: any) {
        if (err.response && err.response.data && err.response.data.error) {
          showTimeAlert(err.response.data.message || "Erro desconhecido", "error");
        } else {
          showTimeAlert("Não foi possivel adicionar o produto.", "error");
        }
        if (emitter && emitter.emit) emitter.emit("addLub:finish", { success: false });
      } finally {
        loading.value = false;
      }
    }

    function verifySelectValues(e) {
      e.preventDefault();
      if (!lubForm.value.tipo || !lubForm.value.marca || !lubForm.value.viscosidade || !lubForm.value.produto) {
        spanWarning.value = true;
        return true;
      }
      spanWarning.value = false;
      addLub();
    }

    function clickLub(clicked) {
      lubClicked.value = clicked;
    }

    async function deleteLub(clicked) {
      loadExcluir.value = true;
      try {
        const res = await axios.post("deletaLubrificante", clicked, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        });
        lubrificantes.value = lubrificantes.value.filter(oleo => oleo.id_lubrificante !== clicked.id_lubrificante);
        allLubrificantes();
        showTimeAlert("Produto deletado com sucesso!");
        auxModal.value.hide(); // Fecha o modal após o alerta
      } catch (err) {
        showTimeAlert("Não foi possivel deletar o produto.", "error");
        auxModal.value.hide(); // Fecha o modal mesmo em caso de erro
      } finally {
        loadExcluir.value = false;
      }
    }

    async function attLub(clicked) {
      let lubFormatPadrao = { ...clicked };
      if (lubFormatPadrao.combustivel) lubFormatPadrao.combustivel = lubFormatPadrao.combustivel.toLowerCase();

      if (!lubFormatPadrao.tipo || !lubFormatPadrao.marca || !lubFormatPadrao.viscosidade || !lubFormatPadrao.produto) {
        spanWarningEdit.value = true;
        clickLub(lubFormatPadrao);
        return;
      }

      if (emitter && emitter.emit) emitter.emit("addLub:start");
      loading.value = true;

      try {
        let body: any = lubFormatPadrao;
        const headers: any = {
          Authorization: `Bearer ${await getToken()}`,
        };

        if (lubFormatPadrao.imagem instanceof File) {
          const formData = new FormData();
          Object.entries(lubFormatPadrao).forEach(([key, val]) => {
            if (key === "imagem") return;
            if (val === undefined || val === null) formData.append(key, "");
            else if (typeof val === "object") formData.append(key, JSON.stringify(val));
            else formData.append(key, String(val));
          });
          formData.append("imagem", lubFormatPadrao.imagem);
          body = formData;
        }

        const res = await axios.post("adicionaLubrificante", body, { headers });

        await allLubrificantes();
        showTimeAlert("Produto atualizado com sucesso!");
        if (emitter && emitter.emit) emitter.emit("addLub:finish", { success: true });
        fechaModalEditLubrificante();
      } catch (err: any) {
        console.log(err);
        if (err.response && err.response.data && err.response.data.error) {
          showTimeAlert(err.response.data.message || "Erro desconhecido", "error");
        } else {
          showTimeAlert("Não foi possivel editar o produto.", "error");
        }
      } finally {
        loading.value = false;
      }
    }

    const openModal = id => {
      const auxElement = document.querySelector(`#${id}`);
      auxModal.value = new Modal(auxElement);
      auxModal.value.show();
    };

    function handlePageChange(pageParam) {
      page.value = pageParam;
      allLubrificantes();
    }


    /* MODAL ADICIONAR LUBRIFICANTE */
    function abrirModalAddLubrificante() {
      ModalAdicionarLubrificante.value.show()
    }

    function fechaModalAddLubrificante() {
      ModalAdicionarLubrificante.value.hide()
    }

    /* MODAL ADICIONAR LUBRIFICANTE*/


    /* MODAL EDITAR LUBRIFICANTE */
    function abrirModalEditLubrificante(item) {
      lubClicked.value = item;
      // envia dados para o componente filho via emitter
      emitter.emit("openEditLub", { lub: item });
      ModalEditarLubrificante.value.show();
    }

    function fechaModalEditLubrificante() {
      ModalEditarLubrificante.value.hide();
    }

    const handleEditFromModal = async (payload: any) => {
      if (!payload || !payload.lub) return;
      await attLub(payload.lub);
    };

    if (emitter && emitter.on) {
      emitter.on("editLub", handleEditFromModal);
    }

    /* MODAL EDITAR LUBRIFICANTE */

    watch(
      () => filtro.value,
      () => {
        page.value = 1;
        if (pagination.value) {
              pagination.value.resetPage(1);
            }
            allLubrificantes()
      }, {deep: true}
    )

    onMounted(() => {
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "bg-body");
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "bg-body");
      getMarcasProduto();
      getToken();
      allLubrificantes();
      ModalAdicionarLubrificante.value = new Modal(document.querySelector(`#ModalAdicionarLubrificante`));
      ModalEditarLubrificante.value = new Modal(document.querySelector(`#ModalEditarLubrificante`));
    });
    
    return {
      spanWarning,
      spanWarningEdit,
      loading,
      totalLubrificantes,
      addLub,
      abrirModalAddLubrificante,
      fechaModalAddLubrificante,
      abrirModalEditLubrificante,
      fechaModalEditLubrificante,
      tipo,
      nome,
      history,
      viscosidade,
      verifySelectValues,
      //tiposDeProdutosRefEntrada,
      lubrificantes,
      openModal,
      clickLub,
      lubClicked,
      deleteLub,
      attLub,
      prodFinded,
      lubForm,
      marcasDeLubrificantes,
      router,
      paginasNumeradas,
      route,
      handlePageChange,
      pagination,
      skeleton,
      handleImgFileChange,
      loadSalvar,
      loadExcluir
    };
  },
});
